/* @flow */
import styled from 'styled-components'
import THEME from './Music1.theme'
import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import WMContainer from '@website/common/components/WMContainer'
import Container from '@website/common/components/Container'

const getStyleForProp = styleProvider(THEME)

const StyledContainer = styled(Container)`
  ${getBackgroundStyles(THEME)};
  align-items: center;
  padding: ${({ isEditing }) => (isEditing ? '150px 0 80px 0' : '80px 0')};
  @media only screen and (max-width: 457px) {
    padding: ${({ isEditing }) => (isEditing ? '120px 0 60px 0' : '60px 0')};
  }
`

const WmCustomContainer = styled(WMContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0;
  @media only screen and (max-width: 1023px) {
    flex-direction: column;
  }
`

const TextContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 1023px) {
    text-align: center;
  }
  @media only screen and (min-width: 993px) {
    max-width: 600px;
  }
  > :last-child {
    margin-bottom: 0;
  }
  & > .control-container {
    margin-bottom: 30px;
    p,
    h1 {
      margin-bottom: 0;
    }
  }
`

const Title = styled.h1`
  color: ${getStyleForProp('heading')};
  margin-bottom: 10px;
  ${getTextStyleByAlignment};
`

const Paragraph = styled.p`
  color: ${getStyleForProp('heading')};
  margin-bottom: 20px;
  ${getTextStyleByAlignment};
`

const Name = styled.p`
  color: ${getStyleForProp('heading')};
  margin-bottom: 0;
  ${getTextStyleByAlignment};
`

const MusicWrapper = styled.div`
  width: 600px;
  min-width: 600px;
  font-size: 0;
  margin: 0 0 0 35px;
  @media only screen and (min-width: 1023px) {
    &:only-child {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  @media only screen and (max-width: 1023px) {
    margin: 40px 0 0 0;
    &:only-child {
      margin: 0;
    }
  }
  @media only screen and (max-width: 650px) {
    min-width: initial;
    width: 100%;
    max-width: 600px;
    margin: 30px 0 0 0;
    &:only-child {
      margin: 0;
    }
  }
`

const MusicContent = styled.div`
  border-radius: ${getStyleForProp('cardRadius')};
  overflow: hidden;
  position: relative;
  width: 100%;
`

const IframeWrapper = styled.div`
  width: 100%;
  position: relative;
  iframe {
    width: 100%;
    height: 166px;
    @media only screen and (max-width: 450px) {
      height: 100px;
    }
  }
`

export default {
  WmCustomContainer,
  StyledContainer,
  Title,
  Paragraph,
  Name,
  MusicContent,
  IframeWrapper,
  TextContent,
  MusicWrapper
}
